export const messageEvents = {
  listeners: new Set(),

  subscribe(callback) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  },

  emit(type, message, duration = 3000) {
    this.listeners.forEach(callback => callback(type, message, duration));
  }
};

export const showSuccess = (message, duration) => messageEvents.emit('success', message, duration);
export const showError = (message, duration) => messageEvents.emit('error', message, duration);
export const showWarning = (message, duration) => messageEvents.emit('warning', message, duration);
export const showInfo = (message, duration) => messageEvents.emit('info', message, duration);